import type { TeamAppModel } from "../../hooks/teamTypes";
import { ArchivedGameDetailScreen } from "../schedule/ArchivedGameDetailScreen";
import { SeasonScreen } from "../season/SeasonScreen";
import { BoxScoreScreen } from "../stats/BoxScoreScreen";

export function HistoryRoute({ model }: { model: TeamAppModel }) {
  const { shell, result, stats, season } = model;

  if (shell.screen === "result") {
    return (
      <ArchivedGameDetailScreen
        game={result.game}
        onBack={() => shell.setScreen("schedule")}
      />
    );
  }

  if (shell.screen === "stats") {
    return (
      <BoxScoreScreen
        rows={stats.rows}
        archivedGameCount={stats.archivedGameCount}
        serverBusy={stats.serverBusy}
        gameId={stats.gameId}
        actionStatus={stats.actionStatus}
        exportError={stats.exportError}
        onShowSeason={() => shell.setScreen("season")}
        onShowGame={() => shell.setScreen("game")}
        onExport={stats.exportExcel}
        onArchive={stats.archive}
      />
    );
  }

  return (
    <SeasonScreen
      regularSummary={season.regularSummary}
      playoffSummary={season.playoffSummary}
      regularGames={season.regularGames}
      playoffGames={season.playoffGames}
      seasons={season.seasons}
      activeSeasonId={season.activeSeasonId}
      hasActiveGame={season.hasActiveGame}
      selectedSeasonId={season.selectedSeasonId}
      onSelectSeason={season.setSelectedSeasonId}
      onShowBoxScore={() => shell.setScreen("stats")}
      onShowGame={() => shell.setScreen("game")}
    />
  );
}
